import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoSummaryAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter';
import {ConsultationCategorySummaryModel} from '../../../api/model/consultationCategorySummary.model';
import {ConsultationCategorySummaryConverter} from '../../../api/model/converter/consultationCategorySummary.converter';
import {ConsultationCategoryModel} from '../../../api/model/consultationCategory.model';
import {ConsultationCategoryDataService} from './consultationCategoryData.service';


@Injectable({providedIn: 'root'})
export class ConsultationCategorySummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<
    ConsultationCategorySummaryModel,
    ConsultationCategorySummaryConverter,
    ConsultationCategoryModel> {
    constructor(dataService: ConsultationCategoryDataService, converter: ConsultationCategorySummaryConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): ConsultationCategoryModel {
        return new ConsultationCategoryModel();
    }
}
